$(function(){
  $(".inview_re").on("inview", function (event, isInView){
    if(isInView){
      $(this).stop().addClass("is-show");
    }else{
      $(this).stop().removeClass("is-show");
    }
  });
});

// ハンバーガーメニュー
$(function() {
  $('.h_menu').click(function(){
    $('.h_menu>a').toggleClass('is_open');
    $('.h_list').toggleClass('is_visible');
    $('body').toggleClass('over_hidden');
  })
});


$(window).on('load', function() {
  slider_01();
  slider_02();
  slider_03();
  logoslider_01();
  logoslider_02();
  logoslider_03();
});

function slider_01() {
  var sliderSelector = '.detailSwiper_01'; // スライダーのコンテナーとなる要素のセレクタ
  var slidesPerView = 3; // スライド表示数
  var $slide = $(sliderSelector + ' .swiper-slide');
  var slidable = $slide.length > slidesPerView;
  // var containerModifierClass =  slidable ? 'is-active swiper-container-' : 'swiper-container-'; // スライドがアクティブな場合は、コンテナー要素にクラス名「is-active」を設定

  // スライド数が足りない場合はloop: false, watchOverflow: true　でスライド無効に設定
  new Swiper('.detailSwiper_01', {
    // containerModifierClass: containerModifierClass,
    spaceBetween: 60,
    grabCursor: true,
    slidesPerView: 1,
    breakpoints: {
      992: {
        slidesPerView: slidesPerView,
      },
    },
    loop: slidable,
    pagination: {
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper01_box .swiper-button-next',
      prevEl: '.swiper01_box .swiper-button-prev',
    },
    watchOverflow: true,
  })
}
function slider_02() {
  var sliderSelector = '.detailSwiper_02'; // スライダーのコンテナーとなる要素のセレクタ
  var slidesPerView = 3; // スライド表示数
  var $slide = $(sliderSelector + ' .swiper-slide');
  var slidable = $slide.length > slidesPerView;
  // var containerModifierClass =  slidable ? 'is-active swiper-container-' : 'swiper-container-'; // スライドがアクティブな場合は、コンテナー要素にクラス名「is-active」を設定

  // スライド数が足りない場合はloop: false, watchOverflow: true　でスライド無効に設定
  new Swiper('.detailSwiper_02', {
    // containerModifierClass: containerModifierClass,
    spaceBetween: 60,
    grabCursor: true,
    slidesPerView: 1,
    breakpoints: {
      992: {
        slidesPerView: slidesPerView,
      },
    },
    loop: slidable,
    pagination: {
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper02_box .swiper-button-next',
      prevEl: '.swiper02_box .swiper-button-prev',
    },
    watchOverflow: true,
  })
}
function slider_03() {
  var sliderSelector = '.detailSwiper_03'; // スライダーのコンテナーとなる要素のセレクタ
  var slidesPerView = 3; // スライド表示数
  var $slide = $(sliderSelector + ' .swiper-slide');
  var slidable = $slide.length > slidesPerView;
  // var containerModifierClass =  slidable ? 'is-active swiper-container-' : 'swiper-container-'; // スライドがアクティブな場合は、コンテナー要素にクラス名「is-active」を設定

  // スライド数が足りない場合はloop: false, watchOverflow: true　でスライド無効に設定
  new Swiper('.detailSwiper_03', {
    // containerModifierClass: containerModifierClass,
    spaceBetween: 60,
    grabCursor: true,
    slidesPerView: 1,
    breakpoints: {
      992: {
        slidesPerView: slidesPerView,
      },
    },
    loop: slidable,
    pagination: {
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper03_box .swiper-button-next',
      prevEl: '.swiper03_box .swiper-button-prev',
    },
    watchOverflow: true,
  })
}

function logoslider_01() {
  var sliderSelector = '.logoSwiper_01'; // スライダーのコンテナーとなる要素のセレクタ
  var slidesPerView = 1; // スライド表示数
  var $slide = $(sliderSelector + ' .swiper-slide');
  var slidable = $slide.length > slidesPerView;

  new Swiper('.logoSwiper_01', {
    spaceBetween: 60,
    grabCursor: true,
    slidesPerView: 1,
    loop: slidable,
    pagination: {
      el: '.logoswiper01_box .swiper-pagination',
      clickable: true,
    },
    speed: 1000,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    watchOverflow: true,
  })
}
function logoslider_02() {
  var sliderSelector = '.logoSwiper_02'; // スライダーのコンテナーとなる要素のセレクタ
  var slidesPerView = 1; // スライド表示数
  var $slide = $(sliderSelector + ' .swiper-slide');
  var slidable = $slide.length > slidesPerView;

  new Swiper('.logoSwiper_02', {
    spaceBetween: 60,
    grabCursor: true,
    slidesPerView: 1,
    loop: slidable,
    pagination: {
      el: '.logoswiper02_box .swiper-pagination',
      clickable: true,
    },
    speed: 1000,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    watchOverflow: true,
  })
}
function logoslider_03() {
  var sliderSelector = '.logoSwiper_03'; // スライダーのコンテナーとなる要素のセレクタ
  var slidesPerView = 1; // スライド表示数
  var $slide = $(sliderSelector + ' .swiper-slide');
  var slidable = $slide.length > slidesPerView;

  new Swiper('.logoSwiper_03', {
    spaceBetween: 60,
    grabCursor: true,
    slidesPerView: 1,
    loop: slidable,
    pagination: {
      el: '.logoswiper03_box .swiper-pagination',
      clickable: true,
    },
    speed: 1000,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    watchOverflow: true,
  })
}

$(function () {
  $('#store_area li a').click(function () {
    $('#store_prefbox').fadeIn();
    $('#storeunder').addClass('storeunder');
    $('.store_areabox').hide();
    $('#store_area li a').removeClass('active');
    $(this).addClass('active');
    $('.store_areabox').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
});

$(function () {
  $('#store_areamodal li a').click(function () {
    $('#store_prefboxmodal').fadeIn();
    $('#storeundermodal').addClass('storeunder');
    $('.store_areaboxmodal').hide();
    $('#store_areamodal li a').removeClass('active');
    $(this).addClass('active');
    $('.store_areaboxmodal').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
});
$(function () {
  $('#store_pref01 li a').click(function () {
    $('#store_pref01 li a').removeClass('active');
    $(this).addClass('active');
    $('.tabContent').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
  $('#store_pref02 li a').click(function () {
    $('#store_pref02 li a').removeClass('active');
    $(this).addClass('active');
    $('.tabContent').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
  $('#store_pref03 li a').click(function () {
    $('#store_pref03 li a').removeClass('active');
    $(this).addClass('active');
    $('.tabContent').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
  $('#store_pref04 li a').click(function () {
    $('#store_pref04 li a').removeClass('active');
    $(this).addClass('active');
    $('.tabContent').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
  $('#store_pref05 li a').click(function () {
    $('#store_pref05 li a').removeClass('active');
    $(this).addClass('active');
    $('.tabContent').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
  $('#store_pref06 li a').click(function () {
    $('#store_pref06 li a').removeClass('active');
    $(this).addClass('active');
    $('.tabContent').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
});